"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.wizard.title': 'Assistente di Onboarding',
    'onboarding.wizard.reset': 'Ripristina',
    'onboarding.wizard.loading': 'Caricamento...',
    'onboarding.wizard.step.progress': 'Passo {current} di {total}',
    'onboarding.wizard.tab.profession': 'Scegli Professione',
    'onboarding.wizard.tab.steps': 'Completa Passi',
    'onboarding.wizard.tab.review': 'Rivedi',
    'onboarding.wizard.tab.completed': 'Completato',
    'onboarding.wizard.profession.title': 'Scegli la Tua Professione',
    'onboarding.wizard.profession.subtitle': 'Seleziona la professione che meglio si adatta al tuo ruolo per ottenere passi di onboarding personalizzati.',
    'onboarding.wizard.profession.select': 'Seleziona',
    'onboarding.wizard.profession.selected': 'Selezionato',
    'onboarding.wizard.profession.continue': 'Continua con {profession}',
    'onboarding.wizard.profession.loading': 'Caricamento professioni...',
    'onboarding.wizard.profession.empty': 'Nessuna professione disponibile. Contatta il tuo amministratore.',
    'onboarding.wizard.navigation.previous': 'Precedente',
    'onboarding.wizard.navigation.next': 'Passo Successivo',
    'onboarding.wizard.navigation.complete': 'Completa Onboarding',
    'onboarding.wizard.navigation.backToSteps': 'Torna ai Passi',
    'onboarding.wizard.navigation.confirmComplete': 'Conferma e Completa',
    'onboarding.wizard.questions.placeholder': 'Inserisci la tua risposta...',
    'onboarding.wizard.questions.required': '*',
    'onboarding.wizard.questions.selectOption': 'Seleziona un\'opzione...',
    'onboarding.wizard.questions.empty': 'Nessuna domanda disponibile per questo passo.',
    'onboarding.wizard.review.title': 'Rivedi il Tuo Onboarding',
    'onboarding.wizard.review.subtitle': 'Rivedi le tue risposte prima di completare il processo di onboarding.',
    'onboarding.wizard.review.profession': 'Professione Selezionata',
    'onboarding.wizard.review.steps': 'Passi Completati',
    'onboarding.wizard.review.notSelected': 'Non selezionato',
    'onboarding.wizard.completed.title': 'Onboarding Completato!',
    'onboarding.wizard.completed.message': 'Congratulazioni! Hai completato con successo il processo di onboarding per {profession}.',
    'onboarding.wizard.completed.fallback': 'la tua professione',
    'onboarding.wizard.completed.startNew': 'Inizia Nuovo Onboarding',
};
